import { render } from "./PortfolioInformation.vue?vue&type=template&id=83e0e5e6&scoped=true"
import script from "./PortfolioInformation.vue?vue&type=script&lang=js"
export * from "./PortfolioInformation.vue?vue&type=script&lang=js"

import "./PortfolioInformation.vue?vue&type=style&index=0&id=83e0e5e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e0e5e6"]])

export default __exports__